import useCustomWindowDimensions from "@hooks/use-custom-window-dimensions";
import { roundness } from "@provider/dripsy";
import { View } from "dripsy";
import React from "react";
import type { ViewStyle } from "react-native";
import { Modal, Platform, Pressable, StyleSheet } from "react-native";
import { ClosableModalContext } from "./closable-modal-context";
import AsyncBoundary from "@components/async-boundary";

function ClosableModal({
  title,
  backAction,
  onRequestClose,
  children,
  isVisible,
  style,
  height = "90%",
  ...rest
}: {
  isVisible: boolean;
  title?: string;
  backAction?: string;
  onRequestClose: () => void;
  style?: ViewStyle;
  children: React.ReactNode;
  height?: number | string;
}) {
  const { width } = useCustomWindowDimensions();
  const isBigScreen = width > 900;
  const value = React.useMemo(() => ({ onRequestClose }), [onRequestClose]);
  const pointerEventsProps = Platform.OS !== "web" ? { pointerEvents: "box-none" as const } : {};

  if (!isVisible) {
    return null;
  }

  return (
    <Modal transparent visible={isVisible} onRequestClose={onRequestClose} {...rest}>
      <Pressable onPress={onRequestClose} style={[StyleSheet.absoluteFill, styles.backdrop]} />
      <View
        {...pointerEventsProps}
        sx={{
          alignItems: "center",
          justifyContent: isBigScreen ? "center" : "flex-end",
          flex: 1,
          width: "100%",
          maxWidth: 700,
          minHeight: 300,
          alignSelf: "center",
          ...(Platform.OS === "web" ? { pointerEvents: "box-none" } : {}),
        }}
      >
        <View
          sx={{
            position: "relative",
            backgroundColor: "#fff",
            color: "$text",
            borderBottomRightRadius: isBigScreen ? roundness : 0,
            borderBottomLeftRadius: isBigScreen ? roundness : 0,
            borderTopLeftRadius: roundness,
            borderTopRightRadius: roundness,
            shadowColor: "$text",
            shadowOffset: {
              width: 0,
              height: 12,
            } as any,
            shadowOpacity: 0.38,
            shadowRadius: 16.0,
            elevation: 24,
            // flex: 1,
            // paddingBottom: "$4",
            width: "100%",
            maxWidth: 700,
            maxHeight: height,
            // px: Platform.select({ web: ["$2", "$3", "$4"], default: "$2" as any }),
          }}
        >
          <View
            sx={{
              flex: 1,
              // paddingTop: insets.top,
              // paddingRight: insets.right,
              // paddingBottom: insets.bottom,
              // paddingLeft: insets.left,
            }}
          >
            <ClosableModalContext.Provider value={value}>
              <AsyncBoundary>{children}</AsyncBoundary>
            </ClosableModalContext.Provider>
          </View>
        </View>
      </View>
    </Modal>
  );
}

const styles = StyleSheet.create({
  noPaddingTop: {},
  header: {
    backgroundColor: "transparent",
    elevation: 0,
  },
  backdrop: {
    backgroundColor: "rgba(0,0,0,0.6)",
    flex: 1,
  },
  root: {},
  headerContainer: {
    width: "100%",
    maxWidth: 700,
  },
});

export default ClosableModal;
